var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 240",
    width: 220,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fad2b7}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m187.2 119.5c0 55.1-34.9 99.8-78 99.8-43 0-77.9-44.7-77.9-99.8 0-86.2 34.9-99.8 77.9-99.8 43.1 0 78 16.2 78 99.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m198.3 119.8c0 10.8-4.3 23.3-12.4 23.3-8.1 0-12.4-12.5-12.4-23.3 0-10.9 4.3-21.1 12.4-21.1 8.1 0 12.4 10.2 12.4 21.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m20.2 119.8c0 10.8 4.3 23.3 12.4 23.3 8.1 0 12.4-12.5 12.4-23.3 0-10.9-4.3-21.1-12.4-21.1-8.1 0-12.4 10.2-12.4 21.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.32b199f1ebff2d602787604e1c2d2f7a.svg";
export { ForwardRef as ReactComponent };